"use client";

import { ShieldCheck, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheAjmTrustGuarantee() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224925" id="warum-securenetics" ref={sectionRef} className="py-20 md:py-32 bg-background text-foreground overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative order-2 lg:order-1 flex justify-center w-full">
            {}
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-accent/20 rounded-[3rem] transform -rotate-3 scale-105 blur-3xl -z-10"></div>
            
            <div className="relative bg-card/40 backdrop-blur-md border border-border/40 rounded-3xl p-10 md:p-14 shadow-2xl shadow-black/50 w-full max-w-[480px] flex flex-col items-center justify-center text-center gap-8 group hover:shadow-primary/20 transition-shadow duration-500">
              <div className="relative">
                <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full scale-150 -z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/securenetics_server_infrastructure.png" alt="SecureNetics High-Tech Infrastructure" className="w-56 md:w-72 h-auto object-contain drop-shadow-[0_0_15px_rgba(0,255,255,0.3)] transform group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="space-y-3">
                <h3 className="font-default text-2xl font-bold text-primary tracking-tight">
                  Technologische Exzellenz
                </h3>
                <p className="text-base text-muted-foreground leading-relaxed px-4 font-sans">
                  Hochmoderne Sicherheitsarchitekturen für den Schutz Ihrer kritischen Unternehmensdaten.
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 space-y-10">
            <div className="space-y-6">
              <Badge className="bg-primary hover:bg-primary/90 text-primary-foreground border-transparent shadow-lg shadow-primary/20 px-5 py-2 text-sm font-bold tracking-widest uppercase rounded-none inline-flex items-center gap-2">
                <ShieldCheck className="w-4 h-4" />
                Enterprise Security
              </Badge>
              
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground tracking-tighter leading-[1.1]">
                Warum <br className="hidden md:block" />
                <span className="text-primary">SecureNetics?</span>
              </h2>
            </div>

            <div className="relative pl-6 md:pl-10 border-l-4 border-primary/50">
              {}
              <div className="absolute -left-4 md:-left-8 -top-12 text-[8rem] md:text-[12rem] font-black font-default text-primary/5 select-none leading-none pointer-events-none">
                24/7
              </div>
              
              <div className="space-y-6 relative z-10">
                <p className="text-xl md:text-2xl text-foreground font-medium leading-relaxed font-default">
                  Wir schaffen Vertrauen in einer digitalen Welt durch kompromisslose Sicherheitsstrategien.
                </p>
                <p className="text-lg text-muted-foreground leading-relaxed font-sans">
                  In einer Zeit zunehmender Cyber-Bedrohungen bieten wir Ihnen eine <strong className="text-primary font-semibold">ganzheitliche Cybersecurity-Lösung</strong>. Von der Infrastrukturberatung bis zur aktiven Netzwerksicherheit sorgen wir dafür, dass Ihre Systeme <strong className="text-foreground font-semibold">nicht nur funktionieren, sondern absolut vertrauenswürdig sind</strong>.
                </p>
              </div>
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="rounded-none px-8 h-14 text-base font-semibold shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/40 transition-all hover:-translate-y-0.5 bg-primary text-primary-foreground">
                <Link to="/SecuritySolutionsPage">
                  Sicherheitslösungen entdecken
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}